import {
  calculateUploadProgress,
  endpointsList,
  getTotalFormDataSize,
  toFormData,
} from '@/helpers';
import axios, { AxiosProgressEvent } from 'axios';
import { IFileMetadata, IWorkspaceDocumentUploadDto } from 'types';
import { computed, ref } from 'vue';

export function useWorkspaceUpload(workspaceId: string, contentTypeId: string) {
  const totalFileSize = ref(0);
  const remainingFileSize = ref(0);

  const uploadProgress = computed(() =>
    calculateUploadProgress(totalFileSize.value, remainingFileSize.value),
  );

  async function uploadDocument(
    metadata: IFileMetadata,
    mainFile: File,
    renditionFile?: File,
  ): Promise<void> {
    const formData = toFormData<IWorkspaceDocumentUploadDto>({
      metadata,
      mainFile,
      renditionFile,
      contentTypeId,
    });
    await setTotalFileSize(formData);
    await axios.post(
      endpointsList.workspaceUploads.uploadDocument(workspaceId),
      formData,
      {
        onUploadProgress: (e: AxiosProgressEvent) => {
          remainingFileSize.value = remainingFileSize.value - e.bytes;
        },
      },
    );
  }

  /**
   * Calculating the total file size of all files to be uploaded for tracking
   * upload progress.
   */
  async function setTotalFileSize(formData: FormData): Promise<void> {
    const totalSize = await getTotalFormDataSize([formData]);
    totalFileSize.value = totalSize;
    remainingFileSize.value = totalSize;
  }

  return { uploadDocument, uploadProgress };
}
